import { ComponentStyleConfig } from '@chakra-ui/react'

export const Heading: ComponentStyleConfig = {
  sizes: {
    h1: {
      fontFamily: 'Satoshi',
      fontSize: '80px',
      lineHeigh: '88px',
    },
    h2: {
      fontFamily: 'Satoshi',
      fontSize: '60px',
      lineHeigh: '66px',
    },
    h3: {
      fontFamily: 'Satoshi',
      fontSize: '48px',
      lineHeigh: '52px',
    },
    h4: {
      fontFamily: 'Satoshi',
      fontSize: '36px',
      lineHeigh: '40px',
    },
    h5: {
      fontFamily: 'Satoshi',
      fontSize: '32px',
      lineHeigh: '40px',
    },
  },
}
